export const META_TYPE = 'cmcAsset';
export const META_VER = 'v1';

export const CMD_CMCASSET_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
